module.exports = __webpack_public_path__ + "img/eth.2ebb0d3d.svg";